var ctaGuideJS = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var guideBannerCTABtn = document.querySelectorAll('.guide-banner-section__btn-wrapper a'),
      guideFeaturedArticleCSFBtn = document.querySelectorAll('.guide-popup-csf__form--btn'),
      guideFooterBannerCTABtn = document.querySelectorAll('.guide-footer-banner-section-cta__popup-csf-btn'),
      otherFreeToolsLinks = document.querySelectorAll('.ft-banner-section__tools-link a'),
      pageSourceEvent = 'GuidePage';
    
    // check for free tools page
    if (document.body.classList.contains("page-template-free-tools-inter-template")) {
      pageSourceEvent = 'FreeTools_Page';
    }

    // For guide page hero banner section CTA event
    if (guideBannerCTABtn.length !== 0) {
      for (var i = 0; i < guideBannerCTABtn.length; i++) {
        guideBannerCTABtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Hero Click", 
              "cta-location": "Hero"
            },
            ((popUpCSFOptions.vwoShow) ? {source: pageSourceEvent + '_Hero'} : {})
            ));
          },
          false
        );
      }
    }

    // For guide page sidebar CTA event
    if (guideFeaturedArticleCSFBtn.length !== 0) {
      for (var i = 0; i < guideFeaturedArticleCSFBtn.length; i++) {
        guideFeaturedArticleCSFBtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Sticky Sidebar", 
              "cta-location": "Sticky Sidebar"
            },
            ((popUpCSFOptions.vwoShow) ? {source: pageSourceEvent + '_Sidebar'} : {})
            ));
          },
          false
        );
      }
    }

    // For guide page footer banner CTA Btn event
    if (guideFooterBannerCTABtn.length !== 0) {
      for (var i = 0; i < guideFooterBannerCTABtn.length; i++) {
        guideFooterBannerCTABtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Bottom CTA Click", 
              "cta-location": "Bottom CTA"
            },
            ((popUpCSFOptions.vwoShow) ? {source: pageSourceEvent + '_BottomCTA'} : {})
            ));
          },
          false
        );
      }
    }

    // For other free tools links event
    if (otherFreeToolsLinks.length !== 0) {
      for (var i = 0; i < otherFreeToolsLinks.length; i++) {
        otherFreeToolsLinks[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " - Other Free Tools Click", 
              "cta-location": "Other Free Tools"
            },
            ((popUpCSFOptions.vwoShow) ? {source: pageSourceEvent + '_OtherTools'} : {})
            ));
          },
          false
        );
      }
    }
  };

  init();
})();